// SCROLL EFFECTS

if ($('.banner').length) {
  if ($('.team-profile').length) {
    if (window.innerWidth < 800) {
      $('.banner').css('background-position', '80% ' + (($(window).scrollTop() / 2) + 20) + 'px');
    } else {
      $('.banner').css('background-position', '50% ' + (($(window).scrollTop() / 2) - 35) + 'px');
    }
  } else {
    $('.banner').css('background-position', 'center ' + ($(window).scrollTop() / 2) + 'px');
  }
}

$(window).scroll(function(){
  var scrollTop = $(window).scrollTop();

  // PARALLAX EFFECTS
  if ($('.parallax-layer').length) {  
    $('.parallax-layer').each(function() {
      var speed = $(this).data('paraspeed');
      var offset = $(this).offset().top - scrollTop - 3000;
      $(this).css('transform', 'translateY(' + (offset / speed) + 'px)');
    });
  }

  if ($('.banner').length) {
    if ($('.team-profile').length) {
      if (window.innerWidth < 800) {
        $('.banner').css('background-position', '80% ' + ((scrollTop / 2) + 20) + 'px');
      } else {
        $('.banner').css('background-position', '50% ' + ((scrollTop / 2) - 35) + 'px');
      }
    } else {
      $('.banner').css('background-position', 'center ' + (scrollTop / 2) + 'px');
    }
  }

  if ($('.img-block').length) {
    $('.img-block').each(function() {
      $(this).css('background-position-y', (scrollTop / 30) + "%");// .css('background-position', '10px 10px')
    });
  }

  if (scrollTop > 80) {
    $('.header').addClass('compressed');
  } else {
    $('.header').removeClass('compressed');
  }
});

$('.logo-letter').addClass('active');
$('#logo-circle').addClass('active');

$('#home-intro .btn-circle').click(function() {

  document.querySelector('#home-stats').scrollIntoView({behavior: "smooth", block: "start"});
});

function animateStatElement(el) {
  var $this = $(el);
  if ($this.data('animated')) return;
  $this.data('animated', true);
  var number = 1;
  var target = parseInt($this.data('max')) || 0;
  var step = Math.max(1, Math.floor(target / 60));
  var interval = setInterval(function() {
    number += step;
    if (number >= target) {
      $this.html(target);
      clearInterval(interval);
    } else {
      $this.html(number);
    }
  }, 16);
}

// Use IntersectionObserver when available, otherwise fallback to checking on scroll/load
var statEls = Array.prototype.slice.call(document.querySelectorAll('.stat__number, .stat-number'));
if (window.IntersectionObserver) {
  var observer = new IntersectionObserver(function(entries, obs) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateStatElement(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  statEls.forEach(function(el) { observer.observe(el); });
} else {
  // fallback: animate when on-screen (checks on load and scroll)
  function checkStatsOnScreen() {
    statEls.forEach(function(el) {
      if (!$(el).data('animated') && $(el).isOnScreen()) {
        animateStatElement(el);
      }
    });
  }
  $(window).on('scroll resize load', checkStatsOnScreen);
  // initial check
  $(document).ready(checkStatsOnScreen);
}

//Check if items are in viewport
$.fn.isOnScreen = function(){
    
  var win = $(window);
  
  var viewport = {
      top : win.scrollTop(),
      left : win.scrollLeft()
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();
  
  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();
  
  return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    
};


// compass arrow rotation on hover
const stats = document.querySelectorAll('.stats .stat');
const compassArrow = document.querySelector('#home-stats .compass-arrow img');

if (compassArrow && stats.length) {
  stats.forEach(stat => {
    const rotateDeg = stat.dataset.rotate;

    stat.addEventListener('mouseenter', () => {
      compassArrow.style.transform = `rotate(${rotateDeg}deg)`;
    });

    stat.addEventListener('mouseleave', () => {
      compassArrow.style.transform = 'rotate(0deg)';
    });
  });
}
  